import { Button, Intent } from "@blueprintjs/core";
import { IconName } from "@blueprintjs/icons";

export interface ButtonProps {
  disabled?: boolean;
  enabled: boolean;
  onClick: () => void;
  icon?: IconName;
  intent: Intent;
}

export const SimpleButton = (props: ButtonProps) => (
  <Button
    disabled={!props.enabled || props.disabled}
    icon={props.icon}
    onClick={props.onClick}
    intent={props.enabled ? props.intent : Intent.NONE}
    minimal={!props.enabled}
  />
);
